'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defaultLang = require('@ks/kwai-ui/lib/locale/lang/zh-CN');
var Vue = require('vue');
var deepmerge = require('deepmerge');
var Format = require('@ks/kwai-ui/lib/locale/format');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var defaultLang__default = /*#__PURE__*/_interopDefaultLegacy(defaultLang);
var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);
var deepmerge__default = /*#__PURE__*/_interopDefaultLegacy(deepmerge);
var Format__default = /*#__PURE__*/_interopDefaultLegacy(Format);

var format = Format__default['default'](Vue__default['default']);
var lang = defaultLang__default['default'];
var merged = false;

var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || Vue__default['default']).$t;

  if (typeof vuei18n === 'function' && !!Vue__default['default'].locale) {
    if (!merged) {
      merged = true;
      Vue__default['default'].locale(Vue__default['default'].config.lang, deepmerge__default['default'](lang, Vue__default['default'].locale(Vue__default['default'].config.lang) || {}, {
        clone: true
      }));
    }

    return vuei18n.apply(this, arguments);
  }
};

var t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;
  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }

  return '';
};
var use = function use(l) {
  lang = l || lang;
};
var i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};
var index = {
  use: use,
  t: t,
  i18n: i18n
};

exports.default = index;
exports.i18n = i18n;
exports.t = t;
exports.use = use;
